import React, { useEffect, useRef, useState, useCallback } from 'react';
import {
  View,
  TouchableOpacity,
  Text,
  StyleSheet,
  FlatList,
  Linking,
  Dimensions,
  ActivityIndicator,
  ScrollView,
  Animated,
  Easing,
} from 'react-native';
import { useDispatch, useSelector, connect } from 'react-redux';
import { Color, globalFontStyle, globalStyle } from '../../assets';
import CommonModal from '../../commonComponents/commonModal';
import Header from '../../commonComponents/Header';
import {
  getConfig,
  setIsLogin,
} from '../../utils/commonredux/commonRedux.action';
import { androidHeader, imgHeader, iosHeader } from '../../utils/images';
import CategoriesHome from './childComponents/categoriesHome';
import Category from './childComponents/sortCategory';
import SubCategories from './childComponents/subCategories';
import TradeCard from './childComponents/tradeCard';
import { fetchProbesRequest, removeProbe } from './redux/home.action';

//import HowtoTradeModal from "./childComponents/howToTrade";
import { Network } from '../../utils/network';
import useDynamicLink from '../../common/useDynamicLink';
import useNotification from '../../common/notification';
import ReactNativeBlobUtil from 'react-native-blob-util';
import {
  checkColums,
  isMobile,
  openURL,
  requestPermision,
  trackMoengageEvent,
} from '../../utils/commonMethods';
import Colors from '../../assets/Color/Colors';
import HowToTradeVideo from './childComponents/howToTradeVideo';
import NoMarket from '../../commonComponents/NoMarkets';
import { showLoader } from '../../commonComponents/Loader/loader.actions';
import { TabActions, useIsFocused } from '@react-navigation/native';
import { setInitialDynamicLinkFired } from '../../utils/commonredux/commonRedux.action';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { globalImport } from '../../common/globalImports';
import HomeBanners from './childComponents/homeBanners';
import {
  globalConfigurableData,
  globalConst,
  GlobalScreens,
  partnerMap,
} from '../../utils/globalConstant';
import HashTagCard from './childComponents/HashTagCard';
import Width from '../../assets/Width';
import MultiCard from './childComponents/multiCard';
import ParentProbeCard from './childComponents/parentProbeCard';
import { RefreshControl } from 'react-native-web-refresh-control';
import { getUser, getUserPartnerProfile } from '../Profile/redux/profile.action';
import { headerSet } from '../../utils/networkFetch';
import { fetchLivePorfolio } from '../portfolio/redux/portfolio.action';
import FormTextLabel from '../../commonComponents/FormTextLabel';
import width from '../../assets/Width';
import Gamification from '../rewards/childComponents/gamification';
import { getGamificationDetails } from '../rewards/redux/rewards.action';
import { useScrollToTop } from '@react-navigation/native';
import HomeFooter from './childComponents/footerHome';
import FastImage from '../../common/FastImage';
import Gradient from '../../commonComponents/Gradient';
import { useToast } from '../../components/core/Toast';
import Icon from 'react-native-vector-icons/MaterialIcons';

const ANNOUNCEMENT_DISMISSED_KEY = 'tradex_announcement_dismissed';

const Home = ({
  route,
  navigation,
  fetchProbesRequest,
  probeData,
  loading,
  appIdle,
  showLoader,
  setInitialDynamicLinkFired,
  isInitialDynamicLinkFired,
  removeProbe,
  profileData,
}) => {
  const dispatch = useDispatch();
  const [isPullToRefresh, setIsPullToRefresh] = useState(false);
  const column = checkColums();
  const insets = useSafeAreaInsets();
  useDynamicLink(
    navigation,
    setInitialDynamicLinkFired,
    isInitialDynamicLinkFired,
  );
  useNotification();
  const probeFlatList = useRef(null);
  const globalConfigData = useSelector(
    state => state.utilReducer.globalConfigData,
  );
  const rewardDetail = useSelector(
    ({ rewardsReducer }) => rewardsReducer?.gamificationDetailData,
  );
  // const ref = React.useRef(null);
  useScrollToTop(probeFlatList);
  const isFirstLogin = route?.params?.isFirstLogin;
  const isLoadProbe = route?.params?.isLoadProbe;
  const [modalVisible, setModalVisible] = useState(false);
  const isFocused = useIsFocused() && !globalImport.isWeb;
  const [FilteredProbe, setFilteredProbe] = useState([]);
  const [FilteredHashTags, setFilteredHashTags] = useState([]);
  const [mulitOptionList, setMultiOptionList] = useState([]);
  const { toast } = useToast();
  const scrollX = useRef(new Animated.Value(0)).current;
  const screenWidth = Dimensions.get('window').width;
  const [showAnnouncement, setShowAnnouncement] = useState(false);

  const PullToRefresh = () => {
    setIsPullToRefresh(true);
    dispatch(getConfig());
    dispatch(getGamificationDetails());
    fetchProbesRequest({ sortingType: parseInt(sortedType) });
  };
  const [sortedType, setSortedType] = useState(null);

  const [categoryObj, setCategoryObj] = useState({
    selectedCategory: '',
    selectedSubCategory: '',
    subCategories: [],
  });

  const onSortPress = sortedItem => {
    if (sortedItem !== sortedType) {
      setSortedType(sortedItem);
      (profileData?.token || globalConst.partnerId === 1 || partnerMap.isTmr) &&
        fetchProbesRequest({ sortingType: parseInt(sortedItem) });
    }
  };

  const formatData = data => {
    if (globalImport.isWeb) {
      const numColumns = column;
      const amountFullRows = Math.floor(data.length / numColumns);
      let amountItemsLastRow = data.length - amountFullRows * numColumns;

      while (amountItemsLastRow !== numColumns && amountItemsLastRow !== 0) {
        data.push({ key: `empty-${amountItemsLastRow}`, empty: true });
        amountItemsLastRow++;
      }
    }

    return data;
  };

  // useEffect(() => {
  //   if (
  //     globalConst.partnerId === 1 &&
  //     globalConfigData?.pages?.is_fantasy_enabled === true &&
  //     !isPullToRefresh &&
  //     isMobile()
  //   ) {
  //     const jumpToAction = TabActions.jumpTo('Contest', {
  //       isFirstLogin: isFirstLogin,
  //     });
  //     //navigation.navigate('Home');
  //     navigation.dispatch(jumpToAction);
  //   }
  // }, [globalConfigData, isPullToRefresh]);

  let userInfo = useSelector(({ profile }) => profile.profileData);
  const isAppLogin = useSelector(({ utilReducer }) => utilReducer.isAppLogin);

  // useEffect(() => {
  //   async function fetchProfile() {
  //     const profile = await AsyncStorage.getItem('CTProfileSet');
  //     if (profile === null && userInfo && !globalImport.isWeb) {
  //       globalImport.CleverTap.onUserLogin({
  //         Name: userInfo?.displayname,
  //         Identity: userInfo?.id?.toString(),
  //         Email: userInfo?.email,
  //         Phone: userInfo?.mobile,
  //         region: userInfo?.region_code,
  //       });
  //       await AsyncStorage.setItem('CTProfileSet', 'true');
  //     }
  //   }
  //   fetchProfile();
  // }, [userInfo]);

  // useEffect(() => {
  //   isMobile() && setModalVisible(!!isFirstLogin);
  // }, [isFirstLogin]);

  useEffect(() => {
    dispatch(getConfig());
  }, []);

  useEffect(() => {
    if (
      globalImport.isWeb &&
      globalConst.partnerId !== 1 &&
      globalConst.partnerId !== partnerMap?.isKostar
    ) {
      var query = window.location.search.substring(1);
      const params = new URLSearchParams(query);
      const payload = decodeURIComponent(params.get('payload'));
      const auth_key = decodeURIComponent(params.get('auth_key'));

      if (auth_key !== 'null' && payload !== 'null') {
        // setError(null);
        dispatch(getUserPartnerProfile(payload, auth_key));
      } else {
        // setError("uuid null");
      }
    }
  }, []);

  useEffect(() => {
    if (
      globalImport.isWeb &&
      globalConst.partnerId !== 1 &&
      !isAppLogin &&
      globalConst.partnerId !== partnerMap?.isKostar
    ) {
      if (profileData && profileData?.token) {
        headerSet(profileData?.token);
        // if (!profileData["ageconsent"]) {
        //   navigation.navigate("Login", {showConsent: true});
        // }
        console.log('profileData.token', profileData.token);
        localStorage.setItem('token', profileData?.token);
        localStorage.setItem('partner', profileData?.partner);
        localStorage.setItem('userMobNumber', profileData?.mobile);
        localStorage.setItem('userProfile', JSON.stringify(profileData));
        dispatch(getConfig());
        dispatch(fetchLivePorfolio());
        dispatch(getUser());
        dispatch(setIsLogin(true));
        fetchProbesRequest({ sortingType: parseInt(sortedType) });
      } else if (profileData?.error) {
        navigation.navigate('PartnerError', {
          message: profileData?.message,
        });
      }
    }
  }, [profileData]);

  useEffect(() => {
    if (!appIdle && isFocused) {
      if (!sortedType) {
        fetchProbesRequest();
      } else {
        fetchProbesRequest({ sortingType: parseInt(sortedType) });
      }
    }
  }, [!appIdle]);

  useEffect(() => {
    if (isLoadProbe) {
      // setCategoryObj({
      //   selectedCategory: "",
      //   selectedSubCategory: "",
      //   subCategories: [],
      // });
      dispatch(getConfig());
      if (!sortedType) {
        fetchProbesRequest();
      } else {
        fetchProbesRequest({ sortingType: parseInt(sortedType) });
      }
    }
  }, [isLoadProbe]);

  const onCategoryUpdate = itemList => {
    trackMoengageEvent('Category_Filter_Click', {
      category: itemList?.text,
    });
    setCategoryObj({
      selectedCategory: itemList?.text,
      selectedSubCategory: '',
      subCategories: itemList?.subcategory,
    });
    /*if (probeFlatList?.current) {
      probeFlatList?.current?.scrollToIndex({
        animated: true,
        index: 0,
      });
    }*/
  };

  const onLearnMore = () => {
    trackMoengageEvent('Clicked on How to trade');
    if (!modalVisible) {
    }
    setModalVisible(!modalVisible);
  };

  const onSubCategoryUpdate = item => {
    let categoryObjUpdated;
    if (item === categoryObj?.selectedSubCategory) {
      categoryObjUpdated = { ...categoryObj, selectedSubCategory: '' };
    } else {
      categoryObjUpdated = { ...categoryObj, selectedSubCategory: item };
    }

    trackMoengageEvent('Clicked on Sub Category', {
      subCategory: categoryObjUpdated,
    });
    setCategoryObj(categoryObjUpdated);
    /*if (probeFlatList?.current) {
      probeFlatList?.current?.scrollToIndex({
        animated: true,
        index: 0,
      });
    }*/
  };

  useEffect(() => {
    trackMoengageEvent('Page Visit', {
      Page: 'Markets',
    });
    // Show announcement when component mounts
    setShowAnnouncement(true);
    if (globalConfigData?.categories && globalConfigData?.categories.length) {
      if (
        categoryObj?.selectedCategory !== '' &&
        globalConfigData?.categories.some(
          cat => cat.text === categoryObj?.selectedCategory,
        )
      ) {
        setCategoryObj({
          selectedCategory: categoryObj?.selectedCategory,
          selectedSubCategory: '',
          subCategories: categoryObj?.subCategories,
        });
      } else {
        setCategoryObj({
          selectedCategory: globalConfigData?.categories[0]?.text,
          selectedSubCategory: '',
          subCategories: globalConfigData?.categories[0]?.subcategory,
        });
      }
    }
  }, [globalConfigData?.categories]);

  const onTelegramClick = () => {
    Linking.openURL(globalConfigData?.telegramLink);
  };

  const onHTTClick = async () => {
    console.log(ReactNativeBlobUtil.fs.dirs.DownloadDir + '/app-release.apk');
    const requestPermision1 = await requestPermision('WRITE_EXTERNAL_STORAGE');
    if (requestPermision1) {
      ReactNativeBlobUtil.config({
        addAndroidDownloads: {
          useDownloadManager: true,
          title: 'App-Testing',
          description: 'An APK that will be installed',
          mime: 'application/vnd.android.package-archive',
          mediaScannable: true,
          notification: true,
          path: ReactNativeBlobUtil.fs.dirs.DownloadDir + '/app-release.apk',
        },
      })
        .fetch('GET', 'https://api.theox.co/getapp')
        .progress((received, total) => {
          console.log('progress', received / total);
        })
        .then(async res => {
          /*
          For deleting the old files
          ReactNativeBlobUtil.fs
            .unlink(
              ReactNativeBlobUtil.fs.dirs.DownloadDir + '/app-release.apk',
            )
            .then(() => {
              console.log('file is deleted');
            })
            .catch(err => {
              console.log('err', err);
            });*/
          /*ReactNativeBlobUtil.android
            .actionViewIntent(
              ReactNativeBlobUtil.fs.dirs.DownloadDir + '/app-release.apk',
              'application/vnd.android.package-archive',
            )
            .then(val => {
              //alert(val);
              console.log('success');
            })
            .catch(err => {
              console.log('error', err);
            });*/
        });
    }

    //setModalVisible(true);
  };

  const onCardClick = item => {
    if (Date.parse(item?.endsat) < Date.now()) {
      removeProbe(item?.id);
      toast({
        title: 'This event is no longer active',
        variant: 'destructive'
      });
    } else {
      showLoader();
      navigation.navigate('Event', {
        eventId: item.id,
        isMulti: item.parent_id === -1 ? true : false,
      });
      // navigation.navigate("Event", { eventData: item });
    }
  };
  const showToast = amount => {
    toast({
      title: `${amount} credits required for creating an event`,
      variant: 'info'
    });
  };

  useEffect(() => {
    if (probeData?.probes && categoryObj?.selectedCategory) {
      const multiOptionFilter = {};

      const hashtags = [];
      const hashTagFilteredList = (probeData?.newHashtags || [])
        .filter(item => {
          if (item.category === categoryObj?.selectedCategory) {
            if (
              categoryObj?.selectedSubCategory === '' &&
              item.subcategory === null
            ) {
              hashtags.push(item?.hashtags);
              return true;
            } else if (item?.subcategory === categoryObj?.selectedSubCategory) {
              hashtags.push(item?.hashtags);
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        })
        .sort((a, b) => {
          return sortHashTag(a, b);
        });
      const filteredProbeList = probeData?.probes.filter(item => {
        if (item.parent_id < 1) {
          if (
            categoryObj?.selectedSubCategory &&
            item.subcategory === categoryObj?.selectedSubCategory &&
            item.category === categoryObj?.selectedCategory &&
            !hashtags.some(r => item.hashtags?.indexOf(r) >= 0)
          ) {
            return true;
          } else if (
            !categoryObj?.selectedSubCategory &&
            item.category === categoryObj?.selectedCategory &&
            !hashtags.some(r => item.hashtags?.indexOf(r) >= 0)
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          if (!multiOptionFilter[item.parent_id]) {
            // Only store the first child event for each parent
            multiOptionFilter[item.parent_id] = [item];
          }
          return false;
        }
      });
      // const hashTagFilteredSet = (probeData?.hashtags || [])
      // .filter((item) => {
      //   if (item.category === categoryObj?.selectedCategory) {
      //     if(categoryObj?.selectedSubCategory === '' && item.subcategory === null){
      //       return true;
      //     }
      //     else if(item?.subcategory === categoryObj?.selectedSubCategory){
      //       return true;
      //     }
      //     else{
      //       return false;
      //     }

      //   } else {
      //     return false;
      //   }
      // });

      // const consolidatedList = [...hashTagFilteredList, ...filteredProbeList];
      if (categoryObj?.selectedCategory === 'All') {
        let filteredProbeListMob;
        if (categoryObj?.selectedSubCategory) {
          filteredProbeListMob = probeData?.probes.filter(item => {
            if (
              item.subcategory === categoryObj?.selectedSubCategory &&
              !hashtags.some(r => item.hashtags?.indexOf(r) >= 0)
            ) {
              return true;
            }
          });
        } else {
          filteredProbeListMob = probeData?.probes;
        }
        setFilteredProbe(filteredProbeListMob);
        setFilteredHashTags([]);
        setMultiOptionList(multiOptionFilter);
      } else {
        setFilteredProbe(filteredProbeList);
        setFilteredHashTags(hashTagFilteredList);
        setMultiOptionList(multiOptionFilter);
      }
    }
  }, [
    categoryObj?.selectedSubCategory,
    categoryObj?.selectedCategory,
    probeData,
  ]);

  const timerExpireCallback = item => {
    //if (Date.parse(item?.endsat) < Date.now()) {
    removeProbe(item?.id);
    // }
  };

  const renderProbeCard = ({ item, index }) => {
    if (item.empty) {
      return <View style={!isMobile() ? { flex: 1 } : { flex: 1 }} />;
    }

    // Base styles for both card types
    const cardStyles = [
      { flex: 1 },
      !isMobile() && {
        boxSizing: 'border-box',
        maxWidth: `${100 / column}%`,
        paddingLeft: index % column === 0 ? 0 : 16,
        paddingRight: index % column === column - 1 ? 0 : 16,
        borderLeft:
          index % column !== 0 ? '1px solid rgba(0, 0, 0, 0.04)' : 'none',
      },
    ];

    // Add padding and borders only for trade cards
    if (!item?.events && !isMobile()) {
      cardStyles.push({
        paddingTop: index < column ? 0 : 32,
        paddingBottom: 32,
        ...(index >= column && { borderTop: '1px solid rgba(0, 0, 0, 0.04)' }),
      });
    }

    const containerStyles = [{ flex: 1 }];

    // Add mobile-specific styles
    if (isMobile()) {
      containerStyles.push({
        marginHorizontal: 16,
        ...(!item?.events && {
          paddingBottom: 18,
          paddingTop: index === 0 ? 0 : 18,
          borderBottom: '1px solid rgba(0, 0, 0, 0.04)',
        }),
      });
    }

    return (
      <View style={cardStyles}>
        <TouchableOpacity
          style={containerStyles}
          onPress={() =>
            item?.events ? hashtagRedirect(item) : onCardClick(item)
          }>
          {item?.events ? (
            <HashTagCard hashTagData={item} />
          ) : item?.parent_id === -1 ? (
            <MultiCard
              trade={item}
              mulitOptionList={mulitOptionList[item.id]}
              onCallback={() => {
                onCardClick(item);
              }}
            />
          ) : (
            <ParentProbeCard trade={item} />
          )}
        </TouchableOpacity>
      </View>
    );
  };

  const hashtagRedirect = item => {
    trackMoengageEvent('Clicked on Hashtag', {
      hashtag: item,
    });
    navigation.navigate('HashTag', {
      hash_tag: item.hashtags,
      selectedSubCategory: categoryObj.selectedSubCategory,
    });
  };

  const accountRedirect = () => {
    navigation.navigate('Account');
  };

  useEffect(() => {
    const startScrolling = () => {
      const textWidth = screenWidth + (isMobile() ? 40 : 32); // Account for padding
      Animated.loop(
        Animated.sequence([
          Animated.timing(scrollX, {
            toValue: -textWidth,
            duration: isMobile() ? 20000 : 15000,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
          Animated.timing(scrollX, {
            toValue: textWidth,
            duration: 0,
            useNativeDriver: true,
          })
        ])
      ).start();
    };
    startScrolling();
  }, []);

  const TickerNotice = () => {
    const noticeText = " Tradexapp.co is not affiliated with Tradex.live. Please stay cautious of misleading claims from unrelated parties";

    return (
      <View style={{
        backgroundColor: '#FFB74D',  // Darker amber color
        paddingVertical: isMobile() ? 8 : 12,
        overflow: 'hidden',
        width: '100%',
        height: isMobile() ? 35 : 40,
        justifyContent: 'center',
        flexDirection: 'row',
        alignItems: 'center',
        borderBottom: '1px solid #FFA726',  // Even darker border for definition
      }}>
        <View style={{
          position: 'absolute',
          left: 0,
          zIndex: 2,
          height: '100%',
          justifyContent: 'center',
          flexDirection: 'row',
          alignItems: 'center',
          backgroundColor: '#FFB74D',  // Matching darker amber color
          paddingLeft: isMobile() ? 12 : 16,
          paddingRight: isMobile() ? 12 : 16,
        }}>
          <Icon name="info" size={isMobile() ? 16 : 18} color="#5D4037" />  {/* Darker icon color */}
          <Text style={[
            globalFontStyle.appFontSubText,
            {
              color: '#5D4037',  // Darker text color for better contrast
              marginLeft: 8,
              lineHeight: isMobile() ? 20 : 18,
              includeFontPadding: false,
              textAlignVertical: 'center',
              fontSize: isMobile() ? 13 : 14,
              fontWeight: 'bold',
            }
          ]}>
            Notice:
          </Text>
        </View>
        <View style={{
          position: 'absolute',
          left: 0,
          right: 0,
          height: '100%',
          backgroundColor: '#FFB74D',  // Matching darker amber color
          zIndex: 1,
        }}>
          <Animated.View style={{
            flexDirection: 'row',
            transform: [{ translateX: scrollX }],
            position: 'absolute',
            left: isMobile() ? 100 : 120,
            right: 0,
            alignItems: 'center',
            height: '100%',
          }}>
            <View style={{ flexDirection: 'row', flexShrink: 0, minWidth: screenWidth - (isMobile() ? 116 : 140) }}>
              <Text style={[
                globalFontStyle.appFontSubText,
                {
                  color: '#5D4037',  // Darker text color for better contrast
                  textAlign: 'center',
                  lineHeight: isMobile() ? 20 : 18,
                  includeFontPadding: false,
                  textAlignVertical: 'center',
                  fontSize: isMobile() ? 13 : 14,
                }
              ]}>
                {noticeText}
              </Text>
            </View>
            <View style={{ flexDirection: 'row', flexShrink: 0, minWidth: screenWidth - (isMobile() ? 116 : 140) }}>
              <Text style={[
                globalFontStyle.appFontSubText,
                {
                  color: '#5D4037',  // Darker text color for better contrast
                  textAlign: 'center',
                  lineHeight: isMobile() ? 20 : 18,
                  includeFontPadding: false,
                  textAlignVertical: 'center',
                  fontSize: isMobile() ? 13 : 14,
                }
              ]}>
                {noticeText}
              </Text>
            </View>
          </Animated.View>
        </View>
      </View>
    );
  };

  function headerComponent() {
    return (
      <>
        {false && (
          <Gradient
            colors={['#212121', '#3C3C3C', '#212121']}
            // locations={[0.017, 0.65]}
            end={{ x: 1, y: -0 }}
            style={{
              flexDirection: 'row',
              // paddingHorizontal: 16,
              alignItems: 'flex-end',
              justifyContent: 'space-between',
            }}>
            <View
              style={{
                marginBottom: 16,
              }}>
              <Text
                style={[
                  globalFontStyle.appFontTitle,
                  {
                    color: globalConfigurableData.contrastTextColor1,
                    paddingBottom: 5,
                    paddingTop: isMobile() ? 17 : 0,
                  },
                ]}
                numberOfLines={1}>
                {'Trade on your opinion'}
              </Text>
              <View
                style={{
                  flexDirection: 'row',
                  gap: 10,
                }}>
                <TouchableOpacity
                  onPress={() =>
                    openURL(
                      'https://apps.apple.com/in/app/tradex-markets/id1608795674',
                    )
                  }>
                  <FastImage
                    style={
                      isMobile()
                        ? { width: 130, height: 42, marginTop: 15 }
                        : { height: 60, width: 170 }
                    }
                    source={iosHeader()}
                  />
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={() =>
                    openURL('https://api.tradexapp.co/getapplication')
                  }>
                  <FastImage
                    style={
                      isMobile()
                        ? { width: 130, height: 42, marginTop: 15 }
                        : { height: 60, width: 170 }
                    }
                    source={androidHeader()}
                  />
                </TouchableOpacity>
              </View>
            </View>
            <FastImage style={{ height: 100, width: 115 }} source={imgHeader()} />
          </Gradient>
        )}

        <View
          style={{
            flexDirection: 'row',
          }}>
          <CategoriesHome
            onCategoryUpdate={onCategoryUpdate}
            selectedCategory={categoryObj?.selectedCategory}
          />
        </View>

        {isAppLogin &&
          globalConst?.partnerId === 1 &&
          isMobile() &&
          rewardDetail?.success &&
          !rewardDetail?.flowComplete &&
          rewardDetail?.active ? (
          <Gamification />
        ) : (
          userInfo?.create_normal_event_enabled &&
          isMobile() && (
            <TouchableOpacity
              style={styles.stripeCreate}
              onPress={() =>
                userInfo?.create_normal_event_clickable
                  ? navigation.navigate('RewardsStack', {
                    screen: 'EventCreate',
                    params: {
                      isNormal: true,
                    },
                  })
                  : showToast(
                    userInfo?.create_normal_event_defaults?.invest_amount,
                  )
              }>
              <Text
                style={[
                  globalFontStyle.appFontSubTextBold,
                  { color: Colors.tradexBlue },
                ]}>
                + Create your own event
              </Text>
            </TouchableOpacity>
          )
        )}

        <View>
          {GlobalScreens?.Home?.isShowBanner ? (
            <HomeBanners
              onLearnMore={onLearnMore}
              isLoadProbe={isLoadProbe}
              screen="home"
              globalConfigData={globalConfigData}
            />
          ) : (
            <View style={{ marginVertical: 10 }} />
          )}
          {/*<TouchableOpacity*/}
          {/*  activeOpacity={0.8}*/}
          {/*  onPress={onTelegramClick}*/}
          {/*  style={styles.telegramBlock}>*/}
          {/*  <Text*/}
          {/*    style={[globalFontStyle.appFontSubText, {color: Color.tradexBlue}]}>*/}
          {/*    Need Trading Tips?{' '}*/}
          {/*    <Text style={styles.telegramUnderline}>*/}
          {/*      {' '}*/}
          {/*      Join Telegram Community*/}
          {/*    </Text>*/}
          {/*  </Text>*/}
          {/*  /!*<Text style={[globalFontStyle.appFontSmallTextBold]}>Click Here</Text>*!/*/}
          {/*  <FastImage*/}
          {/*    resizeMode={FastImage.resizeMode.contain}*/}
          {/*    style={styles.telegramImage}*/}
          {/*    source={telegram()}*/}
          {/*  />*/}
          {/*</TouchableOpacity>*/}
          {/*<View style={{flexDirection: 'row', marginBottom: 18}}>*/}
          {/*  <Category*/}
          {/*    globalConfigData={globalConfigData}*/}
          {/*    onSortPress={onSortPress}*/}
          {/*    sortSelectValue={sortedType}*/}
          {/*  />*/}
          {/*  <TouchableOpacity*/}
          {/*    onPress={onLearnMore}*/}
          {/*    style={[*/}
          {/*      globalStyle.outerElementBox,*/}
          {/*      {*/}
          {/*        paddingHorizontal: 15,*/}
          {/*        paddingVertical: 11,*/}
          {/*        alignSelf: 'flex-start',*/}
          {/*      },*/}
          {/*    ]}>*/}
          {/*    <FastImage*/}
          {/*      resizeMode={FastImage.resizeMode.contain}*/}
          {/*      style={styles.telegramImage}*/}
          {/*      source={httIcon()}*/}
          {/*    />*/}
          {/*    <Text style={[globalFontStyle.appFontSubText, {marginLeft: 2}]}>*/}
          {/*      How to Chi*/}
          {/*    </Text>*/}
          {/*  </TouchableOpacity>*/}
          {/*</View>*/}
          {/*{!isMobile() && (<View style={{flexDirection: 'row'}}>*/}
          {/*  <Category*/}
          {/*      globalConfigData={globalConfigData}*/}
          {/*      onSortPress={onSortPress}*/}
          {/*      sortSelectValue={sortedType}*/}
          {/*  />*/}
          {/*  <CategoriesHome*/}
          {/*      onCategoryUpdate={onCategoryUpdate}*/}
          {/*      selectedCategory={categoryObj?.selectedCategory}*/}
          {/*  />*/}
          {/*</View>)}*/}

          {
            <View
              style={{
                marginTop: 8,
                marginBottom: 12,
                marginHorizontal: isMobile() ? -16 : 0,
              }}>
              <ScrollView
                horizontal
                showsHorizontalScrollIndicator={false}
                contentContainerStyle={{
                  paddingHorizontal: isMobile() ? 16 : 0,
                  gap: 12,
                  flexDirection: 'row',
                  alignItems: 'center',
                }}>
                <Category
                  globalConfigData={globalConfigData}
                  onSortPress={onSortPress}
                  sortSelectValue={sortedType}
                />
                <SubCategories
                  subCategory={categoryObj.subCategories}
                  onSubCategoryUpdate={onSubCategoryUpdate}
                  selectedSubCategory={categoryObj?.selectedSubCategory}
                />
              </ScrollView>
            </View>
          }
          <FlatList
            numColumns={column}
            scrollEnabled={false}
            data={formatData(FilteredHashTags) || []}
            renderItem={renderProbeCard}
            keyExtractor={(item, index) => item.id + ''}
            showsVerticalScrollIndicator={false}
            initialNumToRender={10}
            //getItemLayout={getItemLayoutFun}
            updateCellsBatchingPeriod={15}
          //maxToRenderPerBatch={4}
          />
          {/*probeData?.hashtags && probeData?.hashtags?.length > 0 && (*/}
          {/*<FlatList
            numColumns={column}
            scrollEnabled={false}
            data={formatData(FilteredProbe) || [{ empty: true }]}
            renderItem={renderProbeCard}
            keyExtractor={(item, index) => item.id + ''}
            showsVerticalScrollIndicator={false}
            initialNumToRender={10}
            updateCellsBatchingPeriod={15}
          />*/}
          {/*probeData?.hashtags && probeData?.hashtags?.length > 0 && (
          <View>
            <Text
              style={[globalFontStyle.appFontHeading, styles.mostTradedTitle]}
            >
              Most traded on {globalConst?.appName}
            </Text>
            <FlatList
              horizontal
              data={probeData?.hashtags}
              renderItem={(itemList, index) => {
                return (
                  <TouchableOpacity
                    style={[globalStyle.outerElementBox, styles.categoryStyle]}
                    activeOpacity={0.8}
                    onPress={() => {
                      hashtagRedirect(itemList);
                    }}
                  >
                    <Text style={[globalFontStyle.appFontSubTextBold]}>
                      {itemList?.item}
                    </Text>
                  </TouchableOpacity>
                );
              }}
              keyExtractor={(txn) => txn}
              showsHorizontalScrollIndicator={false}
            />
          </View>
            )*/}
        </View>
      </>
    );
  }

  function footerComponent() {
    return <>{globalImport?.isWeb ? <HomeFooter /> : <View />}</>;
  }

  const handleEmpty = () => {
    return (
      <>
        {loading ? (
          <View
            style={{
              height: '70%',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            {loading && GlobalScreens?.Home?.showLoaderHome ? (
              <ActivityIndicator
                size="large"
                color={globalConfigurableData.loaderColor}
              />
            ) : null}
          </View>
        ) : FilteredHashTags?.length !== 0 &&
          FilteredHashTags ? null : GlobalScreens?.Home?.showLoaderHome ? (
            <NoMarket source="home" />
          ) : null}
      </>
    );
  };

  function sortHashTag(p, q) {
    let a = p?.match_start;
    let b = q?.match_start;

    if (a === b) {
      return 0;
    }

    if (a === null) {
      return 1;
    }
    if (b === null) {
      return -1;
    }

    return a < b ? -1 : 1;
  }

  const getItemLayoutFun = (layoutData, index) => ({
    length: 100 + 52,
    offset: 100 + 52 * index,
    index,
  });

  const [refreshing, setRefreshing] = useState(false);

  const onRefresh = useCallback(async () => {
    setRefreshing(true);
    await fetchProbesRequest();
    setRefreshing(false);
  }, [fetchProbesRequest]);

  const AnnouncementContent = () => (
    <View style={{
      padding: isMobile() ? 20 : 32,
      backgroundColor: globalConfigurableData.backgroundColor
    }}>
      <View style={{
        marginBottom: 24,
        borderBottomWidth: 1,
        borderBottomColor: globalConfigurableData.borderColor,
        paddingBottom: 16
      }}>
        <Text style={[
          globalFontStyle.appFontHeading,
          {
            color: globalConfigurableData.primaryTextColor1,
            fontSize: isMobile() ? 20 : 24,
            marginBottom: 8
          }
        ]}>
          Service Discontinued in India
        </Text>
      </View>

      <ScrollView
        style={{ maxHeight: isMobile() ? '70vh' : '60vh' }}
        showsVerticalScrollIndicator={false}
      >
        <View style={{ marginBottom: 24 }}>
          <Text style={[
            globalFontStyle.appFontSubText,
            {
              color: globalConfigurableData.secondaryTextColor1,
              fontSize: isMobile() ? 14 : 16,
              lineHeight: 22,
              marginBottom: 16
            }
          ]}>
            Thank you for being part of the TradeX journey. We're shifting from a real-money gaming platform to a free-to-play, casual social gaming experience, and have discontinued real money opinion trading services in India.
          </Text>

          <Text style={[
            globalFontStyle.appFontSubText,
            {
              color: globalConfigurableData.secondaryTextColor1,
              fontSize: isMobile() ? 14 : 16,
              lineHeight: 22,
              marginBottom: 24
            }
          ]}>
            For reporting any issue or withdrawing any remaining funds, please contact support@tradexapp.co or raise a ticket via our Help Center.
          </Text>
        </View>

        <View style={{
          marginTop: 16,
          paddingTop: 24,
          borderTopWidth: 1,
          borderTopColor: globalConfigurableData.borderColor,
          alignItems: 'center'
        }}>
          <Text style={[
            globalFontStyle.appFontSubTextBold,
            {
              color: globalConfigurableData.primaryTextColor1,
              textAlign: 'center',
              marginTop: 16,
              fontSize: isMobile() ? 15 : 16
            }
          ]}>
            — Team TradeX
          </Text>
        </View>
      </ScrollView>
    </View>
  );

  // Add useEffect to check announcement state on mount
  useEffect(() => {
    const checkAnnouncementState = async () => {
      try {
        // Check if user is from India - more strict logic
        const userRegion = profileData?.region_code;
        const userSignupCountry = profileData?.signup_country;
        const detectedLocation = globalConfigData?.detected_location;
        const detectedCountryCode = detectedLocation?.country_code;

        // Only show announcement if we are certain user is from India
        const isUserFromIndia =
          userRegion === 'IN' ||
          userSignupCountry === 'IN' ||
          detectedCountryCode === 'IN' ||
          detectedLocation === 'IN';

        // Only show announcement for users from India
        if (isUserFromIndia) {
          setShowAnnouncement(true);
        } else {
          // Explicitly set to false for non-Indian users
          setShowAnnouncement(false);
        }
      } catch (error) {
        console.error('Error checking announcement state:', error);
        // Don't show announcement by default if there's an error
        setShowAnnouncement(false);
      }
    };

    // Only run the check if we have profile data or global config data
    if (profileData || globalConfigData) {
      checkAnnouncementState();
    }
  }, [profileData, globalConfigData]);

  return (
    <View style={[styles.container, isMobile() && styles.mobileContainer]}>
      <CommonModal
        onModalCallBack={onLearnMore}
        showModal={modalVisible}
        customModalStyle={[globalStyle.modalView, { alignItems: 'stretch' }]}>
        <HowToTradeVideo
          onLearnMore={() => {
            setTimeout(() => {
              onLearnMore();
            }, globalConst?.buttonTimer);
          }}
          hTTVideoKey={
            globalImport?.isWeb
              ? globalConfigData?.howToTradeVideo
              : globalConfigData?.hTTVideoKey
          }
        />
      </CommonModal>
      <TickerNotice />
      {!GlobalScreens.Home?.hideHomeHeader ? (
        <Header
          onHTTClick={onLearnMore}
          accountRedirect={accountRedirect}
          selected={'Markets'}
          isProTrader={globalConfigData?.isProTrader}
        />
      ) : (
        <View style={{ marginBottom: 0 }}></View>
      )}
      <View style={{ flex: 1 }}>
        <FlatList
          contentContainerStyle={[
            {
              paddingBottom: globalImport.isWeb ? 0 : 120,
              paddingHorizontal: isMobile() ? 0 : insets.left,
            },
            !isMobile() ? styles.dekstopHomeCards : {},
          ]}
          numColumns={isMobile() ? 1 : column}
          ref={probeFlatList}
          ListHeaderComponent={
            <>
              <View
                style={[
                  { paddingHorizontal: isMobile() ? 16 : 0 },
                  isMobile() && styles.mobileHeader,
                ]}>
                {headerComponent()}
              </View>
              <View style={{ marginTop: isMobile() ? 16 : 24 }} />
            </>
          }
          ListFooterComponent={footerComponent()}
          scrollEnabled={FilteredProbe?.length === 0 ? true : true}
          data={formatData(FilteredProbe) || [{ empty: true }]}
          renderItem={renderProbeCard}
          keyExtractor={(item, index) => item.id + ''}
          showsVerticalScrollIndicator={false}
          initialNumToRender={10}
          updateCellsBatchingPeriod={15}
          refreshControl={
            <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
          }
        />
      </View>
    </View>
  );
};

const mapStateToProps = ({ probesReducer, utilReducer, profile }) => ({
  probeData: probesReducer?.data,
  loading: probesReducer?.loading,
  appIdle: utilReducer?.appIdle,
  isInitialDynamicLinkFired: utilReducer?.isInitialDynamicLinkFired,
  profileData: profile.profileData,
});
const mapDispatchToProps = {
  fetchProbesRequest,
  showLoader,
  setInitialDynamicLinkFired,
  removeProbe,
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);

const styles = StyleSheet.create({
  telegramBlock: {
    backgroundColor: 'rgba(10, 87, 255, 0.1)',
    borderRadius: 500,
    flexDirection: 'row',
    paddingHorizontal: 19,
    paddingVertical: 10,
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 18,
    marginBottom: 20,
  },
  telegramImage: {
    width: 11,
    height: 11,
  },
  telegramUnderline: {
    textDecorationLine: 'underline',
    textDecorationColor: 'red',
    textDecorationStyle: 'solid',
    lineHeight: 20,
  },
  modalStyle: {
    height: Dimensions.get('window').height - 200,
    width: Dimensions.get('window').width - 30,
    borderRadius: 12,
  },
  categoryStyle: {
    paddingHorizontal: 15,
    paddingVertical: 10,
    marginRight: 10,
  },
  mostTradedTitle: {
    color: Colors.black,
    marginVertical: 22,
  },
  dekstopHomeCards: {
    //justifyContent: "center",
    //flexDirection: "row",
    //flexWrap: "wrap",
  },
  stripeCreate: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderWidth: 1,
    borderColor: Color.tradexBlue,
    alignItems: 'center',
    borderStyle: 'dashed',
    borderRadius: 4,
    backgroundColor: 'rgba(10, 87, 255, 0.10)',
    marginTop: 10,
  },
  container: {
    flex: 1,
    backgroundColor: globalConfigurableData.backgroundColor,
  },
  mobileContainer: {
    paddingTop: 0,
  },
  mobileHeader: {
    marginBottom: 8,
  },
});
